import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { Sidebar } from './components/Sidebar';
import { HotelBullPage } from './pages/HotelBullPage';
import { PKBPage } from './pages/PKBPage';
import { DungeonBotPage } from './pages/DungeonBotPage';
import { PermissionsPage } from './pages/PermissionsPage';
import { SystemHealthPage } from './pages/SystemHealthPage';
import { LoginPage } from './pages/LoginPage';
import { GameSessionsPage } from './pages/dungeon/GameSessionsPage';
import { CharacterManagementPage } from './pages/dungeon/CharacterManagementPage';
import { AuthProvider, RequireAuth } from './contexts/AuthContext';
import { UIComponentsTest } from './components/__tests__/UIComponentsTest';
import { AnimatePresence, motion } from 'framer-motion';
import { Header } from './components/Header'; // Keep for mobile for now

export function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          {/* Public routes */}
          <Route path="/login" element={<LoginPage />} />

          {/* Protected routes */}
          <Route path="/*" element={
            <RequireAuth>
              <div className="app-layout">
                <Sidebar />
                <div className="flex flex-col flex-1 min-w-0 overflow-hidden">
                  <div className="md:hidden">
                    <Header />
                  </div>
                  <main className="main-content">
                    <PageRoutes />
                  </main>
                </div>
              </div>
            </RequireAuth>
          } />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}

function PageRoutes() {
  const location = useLocation();
  return (
    <AnimatePresence mode="wait">
      <motion.div
        key={location.pathname}
        initial={{ opacity: 0, y: 10, scale: 0.98 }}
        animate={{ opacity: 1, y: 0, scale: 1 }}
        exit={{ opacity: 0, y: -10, scale: 0.98 }}
        transition={{ duration: 0.3, ease: [0.16, 1, 0.3, 1] }}
        className="flex-1 w-full"
      >
        <Routes location={location}>
          <Route path="/ui-test" element={<UIComponentsTest />} />
          <Route path="/" element={<SystemHealthPage />} />
          <Route path="/hotelbull" element={<HotelBullPage />} />
          <Route path="/pkb" element={<PKBPage />} />
          <Route path="/dungeonbot" element={<DungeonBotPage />} />
          <Route path="/dungeonbot/sessions" element={<GameSessionsPage />} />
          <Route path="/dungeonbot/characters" element={<CharacterManagementPage />} />
          <Route path="/permissions" element={<PermissionsPage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </motion.div>
    </AnimatePresence>
  );
}